import { render, staticRenderFns } from "./oscity-identidad.vue?vue&type=template&id=768476f9&scoped=true"
import script from "./oscity-identidad.vue?vue&type=script&lang=js"
export * from "./oscity-identidad.vue?vue&type=script&lang=js"
import style0 from "./oscity-identidad.vue?vue&type=style&index=0&id=768476f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768476f9",
  null
  
)

export default component.exports